/**
 * 结算单相关路由配置
 */
export default [
    {
        path: '/settlement',
        name: 'SettlementIndex',
        redirect: '/settlement/index'
    },
    {
        path: '/settlement/index',
        name: 'SettlementIndexPage',
        component: () => import('../pages/settlement/SettlementIndex.vue'),
        meta: {
            title: '结算订单',
            keepAlive: true
        }
    },
    {
        path: '/settlement/list',
        name: 'SettlementList',
        component: () => import('../pages/settlement/SettlementList.vue'),
        meta: {
            title: '结算单列表',
            keepAlive: true
        }
    },
    {
        path: '/settlement/detail/:settlementId',
        name: 'SettlementDetail',
        component: () => import('../pages/settlement/SettlementDetail.vue'),
        meta: {
            title: '结算单详情',
            keepAlive: false
        }
    },
    {
        path: '/settlement/invoice/:settlementId',
        name: 'InvoiceManage',
        component: () => import('../pages/settlement/InvoiceManage.vue'),
        meta: {
            title: '发票管理',
            keepAlive: false
        }
    }
] 


// WEBPACK FOOTER //
// ./src/router/settlement.js